var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Tab from '../tab';
import TabPane from '../tab/pane';
import ColorPanel from './colorPanel';
import ImagesPanel from './imagesPanel';
import { StyledCover } from './style';
export { colorsPreset } from './colorsPreset';
export var CoverBackgroundType;
(function (CoverBackgroundType) {
    CoverBackgroundType["TYPE_IMAGE"] = "image";
    CoverBackgroundType["TYPE_COLOR"] = "color";
})(CoverBackgroundType || (CoverBackgroundType = {}));
var ChannelCoverModal = /** @class */ (function (_super) {
    __extends(ChannelCoverModal, _super);
    function ChannelCoverModal(props) {
        var _this = _super.call(this, props) || this;
        _this.callBack = function (type, selectedColor, selectedImage) {
            if (_this.props.onChangeCover) {
                _this.props.onChangeCover(type, selectedColor, selectedImage);
            }
        };
        _this.onChangeColor = function (color) {
            _this.setState({ selectedBackgroundType: CoverBackgroundType.TYPE_COLOR, selectedColor: color });
            _this.callBack(CoverBackgroundType.TYPE_COLOR, color, _this.state.selectedImage);
        };
        _this.onChangeImage = function (image) {
            _this.setState({ selectedBackgroundType: CoverBackgroundType.TYPE_IMAGE, selectedImage: image });
            _this.callBack(CoverBackgroundType.TYPE_IMAGE, _this.state.selectedColor, image);
        };
        _this.state = {
            selectedBackgroundType: _this.props.selectedBackgroundType === CoverBackgroundType.TYPE_IMAGE
                ? CoverBackgroundType.TYPE_IMAGE
                : CoverBackgroundType.TYPE_COLOR,
            selectedColor: _this.props.selectedColor,
            selectedImage: _this.props.selectedImage,
        };
        return _this;
    }
    ChannelCoverModal.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.props.selectedBackgroundType !== prevProps.selectedBackgroundType ||
            this.props.selectedColor !== prevProps.selectedColor ||
            this.props.selectedImage !== prevProps.selectedImage) {
            this.setState({
                selectedBackgroundType: this.props.selectedBackgroundType,
                selectedColor: this.props.selectedColor,
                selectedImage: this.props.selectedImage,
            });
        }
    };
    ChannelCoverModal.prototype.render = function () {
        var _this = this;
        var panes = [
            {
                menuItem: 'Color',
                render: function () { return (React.createElement(TabPane, null,
                    React.createElement(ColorPanel, { onChangeColor: _this.onChangeColor, selectedColor: _this.state.selectedColor }))); },
            },
            {
                menuItem: 'Image',
                render: function () { return (React.createElement(TabPane, null,
                    React.createElement(ImagesPanel, { onUploadClick: _this.props.onUploadClick, onChangeImage: _this.onChangeImage, images: _this.props.imageList || [] }))); },
            },
        ];
        return (React.createElement(StyledCover, { type: this.state.selectedBackgroundType, size: "medium", color: this.state.selectedColor, image: this.state.selectedImage },
            React.createElement("div", { className: "column-left" },
                React.createElement("div", { className: "cover-thumbnail" })),
            React.createElement("div", { className: "column-right" },
                React.createElement(Tab, { className: "cover-type-picker", panes: panes }))));
    };
    return ChannelCoverModal;
}(React.Component));
export default ChannelCoverModal;
//# sourceMappingURL=index.js.map